import React from 'react';
import './dropdownMenuCompactProfileHeader.scss';

export interface DropdownMenuCompactHeaderProps {
    title: string;
    subtitle: string;
}

function DropdownMenuCompactHeader({title, subtitle}: DropdownMenuCompactHeaderProps): JSX.Element {
    const getTile = (): JSX.Element => (
        <div className="c-dropdownMenuCompactHeader">
            <div className="c-dropdownMenuCompactHeader_title">{title}</div>
            <div className="c-dropdownMenuCompactHeader_subtitle">{subtitle}</div>
        </div>
    );

    return getTile();
}

export default DropdownMenuCompactHeader;
